import { createInjector } from '../factories/createInjector.js';
import { prefix } from '../utils/index.js';
export const injectRef = createInjector('injectRef', (instance, initialVal) => ({
    result: { current: initialVal },
    type: `${prefix}/ref`,
}));
